import styled from '@emotion/styled';

export const ErrorMessageWrapper = styled.div`
    position: absolute;
    top: 20%;
    left: 50%;
    transform: translate(-50%, -50%)
`;
